import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import Icon from '../icon';
import { cs } from '../utils';
import { useListContext } from './context';
/** Displays an icon on the side of the ListItem. */
export const ListIcon = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('List', useListContext());
    return _jsx(Icon, { className: cs('vui-listIcon', className), ref: ref, ...styles.icon, ...rest });
});
ListIcon.displayName = 'ListIcon';
export default ListIcon;
